import { combine, withCallbacks, withContext } from 'react-hooks-combine'
import { ServicesContext } from 'services/context'
import { auth } from 'routes/route.map'
import { toaster } from 'utils/toast-wrapper'

import SignupSponsorConfirmComponent from './component'

export default combine({
  hooks: [
    withContext(
      'preRegistrationPublicService',
      ServicesContext,
      ({ preRegistrationPublicService }) => preRegistrationPublicService
    ),
    withCallbacks(
      {
        getPreRegSponsorPublicInfo:
          ({ preRegistrationPublicService }, { match }) =>
          async () => {
            const { token } = match.params
            const content =
              await preRegistrationPublicService.getPreRegSponsorPublic(token)
            return content
          },
        onSubmit:
          ({ preRegistrationPublicService }, { history, match }) =>
          async (registrationData) => {
            const { token } = match.params
            await preRegistrationPublicService.confirmPreRegSponsorPublic(
              token,
              registrationData
            )
            toaster.success('Your registration has been confirmed')
            history.push(auth.login())
          },
      },
      []
    ),
  ],
  transformProps: ({ onSubmit, getPreRegSponsorPublicInfo, match }) => {
    const { token } = match.params
    return {
      onSubmit,
      getPreRegSponsorPublicInfo,
      token,
    }
  },
})(SignupSponsorConfirmComponent)
